module.exports = __webpack_public_path__ + "static/media/its-only-natural.46a3ab5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/its-only-natural.jpg
// module id = 248
// module chunks = 0